<template>
  <div>
    <div v-for="(group, index) in campaignGroupList" :key="index" :class="[ab_default === group ? '' : 'hide']">
      <slot :name="'txtContentForGroup' + group" v-if="getSlotText('txtContentForGroup' + group) !== '' && ab_default === group"></slot>
    </div>
    <slot name="txtContentForGroupDefault" v-if="ab_default === false && getSlotText('txtContentForGroupDefault') !== ''"></slot>
  </div>
</template>

<script>

import useABTesting from '@/mixins/useABTesting'
export default {
  name: 'ABTestingContent',
  mixins: [
    useABTesting()
  ]
}
</script>
